import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpPanel } from 'dtp-react-components';
import { Input, Grid, Button } from '../../../components';
import Masks from '../../../utils/masks';
import { trataMensagensErro, requestSalvaComplementoTitulo, requestApagaComplementoTitulo } from '../../../utils/requests';
import { visoesControlePagamento, estadosPagamento, estadosDebitosPendentes, tipoEntidadeControlePagamento,
  tipoEntidadeDebitosPendentes, tipoRegime, estadosPendenciasRGPS,
  estadosPendenciasRPPSaReceber, estadosPendenciasRPPSaPagar, tipoEntidadeControlePagamentoRGPS,
  visoesPendenciasRGPS } from '../../../utils/listsSelect';
import { ehPapelObservadorPagamento } from '../../../utils/helpers';
import SelecaoEntidade from '../../relatorios/SelecaoEntidade';

const participanteRGPS = '01000';
// const participanteINSSUniao = '98222';
// const participanteDECIPEX = '98026';

const rowStyle = {
  width: '2px',
  paddingRigth: '10px',
};
const spanStyle = {
  margin: '0px',
  position: 'relative',
  color: '#44707B',
  top: '25px',
  padding: '5px',
};

class FiltroControlePagamentos extends Component {
  constructor() {
    super();
    this.filtroControlePagamento = JSON.parse(sessionStorage.getItem('filtroControlePagamento'));

    this.state = {
      visaoControlePagamento: this.filtroControlePagamento &&
      this.filtroControlePagamento.visaoControlePagamento ?
        this.filtroControlePagamento.visaoControlePagamento : null,

      estadoPagamento: this.filtroControlePagamento &&
      this.filtroControlePagamento.estadoPagamento ?
        this.filtroControlePagamento.estadoPagamento : null,

      participanteLogado: this.participanteLogado &&
      this.filtroControlePagamento.participanteLogado ?
        this.filtroControlePagamento.participanteLogado : null,

      'destinatario-rpps':
      this.filtroControlePagamento && this.filtroControlePagamento['destinatario-rpps'] ?
        this.filtroControlePagamento['destinatario-rpps'] : null,

      cliqueiNoBotao:
        this.filtroControlePagamento && this.filtroControlePagamento.cliqueiNoBotao ?
          this.filtroControlePagamento.cliqueiNoBotao : null,

      tipoEntidade:
      this.filtroControlePagamento && this.filtroControlePagamento.tipoEntidade ?
        this.filtroControlePagamento.tipoEntidade : null,

      uf:
      this.filtroControlePagamento && this.filtroControlePagamento.uf ?
        this.filtroControlePagamento.uf : null,

      competencia:
        this.filtroControlePagamento && this.filtroControlePagamento.competencia ?
          this.filtroControlePagamento.competencia : null,

      exibirCampoNome:
        this.filtroControlePagamento && this.filtroControlePagamento.exibirCampoNome ?
          this.filtroControlePagamento.exibirCampoNome : false,

      complementoTitulo:
        this.filtroControlePagamento && this.filtroControlePagamento.complementoTitulo ?
          this.filtroControlePagamento.complementoTitulo : '',

      tipoRegimeObservador: this.filtroControlePagamento && this.filtroControlePagamento.tipoRegimeObservador ?
        this.filtroControlePagamento.tipoRegimeObservador : null,

      tipoEntidadeObservador: this.filtroControlePagamento && this.filtroControlePagamento.tipoEntidadeObservador ?
        this.filtroControlePagamento.tipoEntidadeObservador : null,

      uFObservador: this.filtroControlePagamento && this.filtroControlePagamento.uFObservador ?
        this.filtroControlePagamento.uFObservador : null,

      participanteObservador: this.filtroControlePagamento && this.filtroControlePagamento.participanteObservador ?
        this.filtroControlePagamento.participanteObservador : null,

      desconsiderarFluxosExtraordinarios: this.filtroControlePagamento && this.filtroControlePagamento.desconsiderarFluxosExtraordinarios ?
        this.filtroControlePagamento.desconsiderarFluxosExtraordinarios : null,
    };
  }

  componentDidMount() {
    if (this.props.visaoRota) {
      this.handleSearchButtonRota(Number(this.props.visaoRota));
    } else {
      if (sessionStorage.getItem('tipoControle')) {
        if ((sessionStorage.getItem('tipoControle') !== this.props.tipoControle) ||
        this.props.history.action !== 'POP') {
          this.preparaNovaConsulta();
        }
      }
      if (sessionStorage.getItem('filtroControlePagamento')) {
        const itemSession = JSON.parse(sessionStorage.getItem('filtroControlePagamento'));
        if ((itemSession.competencia !== null && itemSession.visaoControlePagamento !== null) ||
        (sessionStorage.getItem('tipoControle') === this.props.tipoControle && this.props.history.action === 'POP')) {
          this.handleSearchButton();
        }
      }
      requestApagaComplementoTitulo();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
    if (this.props.tipoControle !== prevProps.tipoControle) {
      this.preparaNovaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    let filtroControlePagamento = {
      competencia: null,
      visaoControlePagamento: null,
      estadoPagamento: null,
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
    };

    if (ehPapelObservadorPagamento(this.props.papelUsuarioLogado) || this.state.tipoRegimeObservador) {
      filtroControlePagamento = {
        ...filtroControlePagamento,
        tipoRegimeObservador: null,
        participanteObservador: null,
        tipoEntidadeObservador: null,
        uFObservador: null,
      };
      this.setState({
        tipoRegimeObservador: null,
        participanteObservador: null,
        tipoEntidadeObservador: null,
        uFObservador: null,
      });
    }

    if (this.state.exibirCampoNome === true) {
      this.setState({ exibirCampoNome: false });
    }

    filtroControlePagamento = JSON.stringify(filtroControlePagamento);
    sessionStorage.setItem('filtroControlePagamento', filtroControlePagamento);

    this.setState({
      competencia: null,
      visaoControlePagamento: null,
      estadoPagamento: null,
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
      desconsiderarFluxosExtraordinarios: false,
    });
  }

  handleChange = (changeObj, name) => {
    if (name === 'visaoControlePagamento') {
      if (this.props.tipoControle === 'pendencias') {
        this.setState({ complementoTitulo: this.montaComplementoTitulo(changeObj.value), estadoPagamento: null });
      } else {
        this.setState({ complementoTitulo: this.montaComplementoTitulo(changeObj.value) });
      }
    }

    if (name === 'tipoRegimeObservador') {
      if (changeObj.value === 1) {
        this.setState({ participanteObservador: participanteRGPS, tipoEntidadeObservador: null, uFObservador: null });
      } else {
        this.setState({ participanteObservador: null, tipoEntidadeObservador: null, uFObservador: null });
        if (this.props.tipoControle === 'controle-debitos-pendentes') {
          this.setState({
            tipoEntidade: null,
            uf: null,
            'destinatario-rpps': null,
            exibirCampoNome: false,
          });
        }
      }
      if (this.props.tipoControle !== 'controle-debitos-pendentes') {
        this.alterarPreenchimentoDoTipoEntidade(changeObj.value, this.state.tipoEntidade);
        this.limparPreenchimentoDaVisao();
      }
    }
    // this.setState({tipoRegimeObservador: changeObj.value}, this.filtrarRegimes);
    if (name === 'tipoEntidadeObservador') {
      this.setState({ participanteObservador: null, uFObservador: null });
    }

    if (name === 'tipoRegime') {
      if (changeObj.value === 1) {
        this.setState({ participante: participanteRGPS });
      }
    }

    this.setState(
      {
        [name]: changeObj.value,
      }
      , () => this.trataFormulario(name),
    );
  }

  alterarPreenchimentoDoTipoEntidade = (tipoDeRegimeObservador, tipoEntidade) => {
    if (this.props.tipoControle === 'controle-pagamentos') {
      if (tipoDeRegimeObservador === 1 && tipoEntidade === '01000') {
        this.setState({ tipoEntidade: null });
      }
    } else if (this.props.tipoControle === 'pendencias') {
      if (tipoDeRegimeObservador === 1 && (tipoEntidade === 1 || tipoEntidade === '01000')) {
        this.setState({
          tipoEntidade: null,
          'destinatario-rpps': null,
          exibirCampoNome: false,
        });
      }
    }
    if (tipoDeRegimeObservador === '') {
      this.setState({
        tipoEntidade: null,
        uf: null,
        'destinatario-rpps': null,
        exibirCampoNome: false,
      });
    }
  }

  limparPreenchimentoDaVisao = () => {
    if (this.props.tipoControle === 'pendencias') {
      this.setState({ visaoControlePagamento: null });
    }
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSearchButton();
    }
    return retorno;
  }

  /**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'visaoControlePagamento') {
      let complementoTitulo = {
        complementoTitulo: this.state.complementoTitulo,
      };
      complementoTitulo = JSON.stringify(complementoTitulo);
      requestSalvaComplementoTitulo(complementoTitulo);
    }
  }

  trataUf = () => {
    this.setState({ 'destinatario-rpps': null, exibirCampoNome: true });
  }

  trataTipoEntidade = () => {
    const paramTipoEntidade = this.state.tipoEntidade;
    this.setState({
      'destinatario-rpps': null,
      uf: null,
      exibirCampoNome: (paramTipoEntidade === 1 || paramTipoEntidade === 3),
    });
  }

  handleSearchButtonRota = (visaoRota) => {
    let filtroControlePagamento = {};
    const { tipoControle } = { ...this.props };

    filtroControlePagamento = {
      visaoControlePagamento: visaoRota,
    };

    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: visaoRota,
          isValid: true,
        }, 'visaoControlePagamento');
      },
    );

    filtroControlePagamento = JSON.stringify(filtroControlePagamento);
    sessionStorage.setItem('filtroControlePagamento', filtroControlePagamento);
    sessionStorage.setItem('tipoControle', tipoControle);
    this.handleSearch();
  }

  handleSearchButton = () => {
    let filtroControlePagamento = {};
    const { tipoControle } = { ...this.props };
    if (this.state.tipoEntidade === participanteRGPS) {
      filtroControlePagamento = {
        competencia: this.state.competencia,
        visaoControlePagamento: this.state.visaoControlePagamento,
        estadoPagamento: this.state.estadoPagamento,
        'destinatario-rpps': participanteRGPS,
        tipoEntidade: participanteRGPS,
        desconsiderarFluxosExtraordinarios: this.state.desconsiderarFluxosExtraordinarios,
      };
    } else {
      filtroControlePagamento = {
        competencia: this.state.competencia,
        visaoControlePagamento: this.state.visaoControlePagamento,
        estadoPagamento: this.state.estadoPagamento,
        'destinatario-rpps': this.state['destinatario-rpps'],
        tipoEntidade: this.state.tipoEntidade,
        uf: this.state.uf,
        desconsiderarFluxosExtraordinarios: this.state.desconsiderarFluxosExtraordinarios,
      };
    }

    if (ehPapelObservadorPagamento(this.props.papelUsuarioLogado) || this.state.tipoRegimeObservador) {
      filtroControlePagamento = {
        ...filtroControlePagamento,
        tipoRegimeObservador: this.state.tipoRegimeObservador,
        participanteObservador: this.state.participanteObservador,
        tipoEntidadeObservador: this.state.tipoEntidadeObservador,
        uFObservador: this.state.uFObservador,
        desconsiderarFluxosExtraordinarios: this.state.desconsiderarFluxosExtraordinarios,
      };
    }
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );

    if (filtroControlePagamento.tipoEntidade && this.state.exibirCampoNome === false &&
    (filtroControlePagamento.tipoEntidade === 2 && filtroControlePagamento.uf)) {
      this.setState({ exibirCampoNome: true });
    } else if ((filtroControlePagamento.tipoEntidade === 1 || filtroControlePagamento.tipoEntidade === 3) &&
    this.state.exibirCampoNome === false) {
      this.setState({ exibirCampoNome: true });
    }

    filtroControlePagamento = JSON.stringify(filtroControlePagamento);
    sessionStorage.setItem('filtroControlePagamento', filtroControlePagamento);
    sessionStorage.setItem('tipoControle', tipoControle);
    this.handleSearch();
  }

  verificacaoTipoEntidade = () => {
    if (this.state.tipoEntidade) {
      if (this.state.tipoEntidade === 2 && !this.state.uf && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha uma UF']);
        return;
      }
      if (this.state.tipoEntidade !== participanteRGPS) {
        if (this.state.tipoEntidade && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
          return;
        }
        if (this.state.tipoEntidade && this.state.uf && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
          return;
        }
      }
      this.props.handleSearchFilter(this.state);
    } else {
      this.props.handleSearchFilter(this.state);
    }
  }

  handleSearch = () => {
    if (this.props.visaoRota != null && this.state.visaoControlePagamento == null) {
      this.props.handleSearchPorRota(Number(this.props.visaoRota));
    } else if ((this.props.visaoRota !== null && this.state.visaoControlePagamento != null) ||
      (this.props.visaoRota === undefined && this.state.visaoControlePagamento === null)) {
      if (ehPapelObservadorPagamento(this.props.papelUsuarioLogado) && !this.state.tipoRegimeObservador) {
        trataMensagensErro(['Selecione o participante Observador.']);
      } else if (this.state.tipoRegimeObservador &&
        ((!this.state.tipoEntidadeObservador && !this.state.participanteObservador) ||
        ((this.state.tipoEntidadeObservador === 2 && !this.state.uFObservador) || !this.state.participanteObservador))) {
        trataMensagensErro(['Selecione uma opção de Visualização.']);
      } else {
        switch (this.props.tipoControle) {
          case 'controle-pagamentos':
            if (this.state.visaoControlePagamento && this.state.competencia) {
              this.verificacaoTipoEntidade();
            } else {
              trataMensagensErro(['É necessario informar uma competência e a visão.']);
            }
            break;
          case 'pendencias':
            if (this.state.visaoControlePagamento) {
              this.verificacaoTipoEntidade();
            } else {
              trataMensagensErro(['É necessario informar uma visão.']);
            }
            break;
          default: this.verificacaoTipoEntidade();
        }
      }
    }
  }

  listaFiltradaDestinatarios = () => {
    const listaOrgaosFederais = [];
    let listaParticipantes = this.props.destinatarios.filter((item) => {
      // if (item.inOrgaoCentralizador === 1) {
      //   listaOrgaosFederais.push(item);
      // } else if (!(item.inOrgaoExtinto) &&
      //   ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
      //   return item;
      // }
      // return null;
      if ((item.inOrgaoUniao) && (((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 1) || ((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 0))) {
        listaOrgaosFederais.push(item);
      } else if ((!item.inOrgaoExtinto) &&
        ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
        return item;
      }
      return null;
    });
    if (listaOrgaosFederais.length > 0 && this.state.tipoEntidade === 1) {
      listaParticipantes = listaOrgaosFederais;
    }
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  montaComplementoTitulo = (visao) => {
    let complemento = '';
    if (visao && visao !== '' && visao !== undefined) {
      if (visao === 1) {
        complemento = 'Valores a receber';
      } else {
        complemento = 'Valores a pagar';
      }
    }
    return complemento;
  }

  verificaTamanhoInputEstado = () => {
    let retorno = '4 4 4 4';
    if (this.state.estadoPagamento === 9) {
      retorno = '6 6 6 6';
    }
    return retorno;
  }

  itemListDoTipoEntidade = (tipoControle, papelUsuarioLogado, tipoRegimeObservador) => {
    let listaTipoEntidade;
    switch (tipoControle) {
      case 'controle-pagamentos':
        if (papelUsuarioLogado === 'analista-rgps' || tipoRegimeObservador === 1) {
          listaTipoEntidade = tipoEntidadeControlePagamentoRGPS;
        } else {
          listaTipoEntidade = tipoEntidadeControlePagamento;
        }
        break;
      case 'controle-debitos-pendentes':
        listaTipoEntidade = tipoEntidadeDebitosPendentes;
        break;
      case 'pendencias':
        if (papelUsuarioLogado === 'analista-rgps' || tipoRegimeObservador === 1) {
          listaTipoEntidade = tipoEntidadeDebitosPendentes;
        } else {
          listaTipoEntidade = tipoEntidadeControlePagamento;
        }
        break;
      default:
        listaTipoEntidade = [];
        break;
    }

    return listaTipoEntidade;
  }

  itemListDoEstadoPagamento = (tipoControle, papelUsuarioLogado, visao) => {
    let listaEstadoPagamento;
    switch (tipoControle) {
      case 'controle-pagamentos':
        listaEstadoPagamento = estadosPagamento;
        break;
      case 'controle-debitos-pendentes':
        listaEstadoPagamento = estadosDebitosPendentes;
        break;
      case 'pendencias':
        listaEstadoPagamento = this.verificaPapelLogadoEvisaoDePendencias(papelUsuarioLogado, visao);
        break;
      default:
        listaEstadoPagamento = [];
        break;
    }
    return listaEstadoPagamento;
  }

  verificaPapelLogadoEvisaoDePendencias = (papelUsuarioLogado, visao) => {
    let listaEstadoPendencias;
    if (papelUsuarioLogado === 'analista-rgps' || this.state.tipoRegimeObservador === 1) {
      listaEstadoPendencias = estadosPendenciasRGPS;
    } else if (visao && (papelUsuarioLogado === 'analista-rpps' || this.state.tipoRegimeObservador === 2)) {
      if (visao === 1) {
        listaEstadoPendencias = estadosPendenciasRPPSaReceber;
      } else {
        listaEstadoPendencias = estadosPendenciasRPPSaPagar;
      }
    } else {
      listaEstadoPendencias = [];
    }
    return listaEstadoPendencias;
  }

  itemListVisao = (tipoControle, papelUsuarioLogado, tipoRegimeObservador) => {
    let listaVisao = visoesControlePagamento;
    if (tipoControle === 'pendencias') {
      if ((papelUsuarioLogado === 'analista-rgps' ||
        (ehPapelObservadorPagamento(papelUsuarioLogado) && tipoRegimeObservador === 1))) {
        listaVisao = visoesPendenciasRGPS;
      }
    }
    return listaVisao;
  }

  montaFiltros() {
    return (
      <React.Fragment>
        {ehPapelObservadorPagamento(this.props.papelUsuarioLogado) ?
          <div>
            <SelecaoEntidade
              handleChange={this.handleChange}
              destinatarios={this.props.destinatarios}
              papelUsuarioLogado={this.props.papelUsuarioLogado}
              titulo="Visualizar como"
              retirarLinhaSeparadora={false}
              tipoRegime={this.state.tipoRegimeObservador}
              tipoEntidade={this.state.tipoEntidadeObservador}
              uf={this.state.uFObservador}
              participante={this.state.participanteObservador}
              nomeAtributoComboboxRegime="tipoRegimeObservador"
              nomeAtributoComboboxParticipante="participanteObservador"
              nomeAtributoComboboxTipoEntidade="tipoEntidadeObservador"
              nomeAtributoComboboxUF="uFObservador"
              listaTiposRegimes={tipoRegime}
              labelComboboxParticipante="Participante Observador"
            />
            <hr style={{ border: '1px solid #DCDCDC' }} />
          </div>
        : '' }
        <div className="row">
          {/* {this.props.tipoControle === 'controle-pagamentos' && */}
          <div>
            {this.props.tipoControle === 'controle-pagamentos' &&
            <Grid cols="4 4 4 4">
              <Input
                mask={Masks.competencia}
                label="Competência"
                onChange={e => this.handleChange(e, 'competencia')}
                onKeyDown={e => this.handleKeyDown(e, 'competencia')}
                value={this.state.competencia}
                required
              />
            </Grid>
            }
            {(this.props.tipoControle === 'controle-pagamentos' || this.props.tipoControle === 'pendencias') &&
              <Grid cols="4 4 4 4">
                <Input
                  label="Visão"
                  onChange={e => this.handleChange(e, 'visaoControlePagamento')}
                  value={this.state.visaoControlePagamento}
                  itemList={this.itemListVisao(this.props.tipoControle, this.props.papelUsuarioLogado, this.state.tipoRegimeObservador)}
                  placeholder="Selecione a visão"
                  number
                  custom
                  required
                />
              </Grid>
            }
          </div>
          <div>
            <Grid cols={this.props.tipoControle === 'controle-pagamentos' ? '4 4 4 4' : this.verificaTamanhoInputEstado()}>
              <Input
                label="Estado do pagamento"
                onChange={e => this.handleChange(e, 'estadoPagamento')}
                value={this.state.estadoPagamento}
                itemList={this.itemListDoEstadoPagamento(this.props.tipoControle, this.props.papelUsuarioLogado, this.state.visaoControlePagamento)}
                placeholder="Selecione o estado do pagamento"
                number
                custom
              />
            </Grid>
          </div>
          {/* } */}
        </div>
        {(this.props.tipoControle !== 'controle-debitos-pendentes' ||
        (this.props.tipoControle === 'controle-debitos-pendentes' && this.props.papelUsuarioLogado === 'analista-rgps') ||
        (ehPapelObservadorPagamento(this.props.papelUsuarioLogado) && this.state.tipoRegimeObservador !== 2)) &&
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                label="Tipo"
                onChange={e => this.handleChange(e, 'tipoEntidade')}
                placeholder="Selecione a entidade"
                value={this.state.tipoEntidade}
                itemList={this.itemListDoTipoEntidade(this.props.tipoControle, this.props.papelUsuarioLogado, this.state.tipoRegimeObservador)}
                custom
                number
              />
            </Grid>
            {this.state.tipoEntidade === 2 ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="UF"
                  onChange={e => this.handleChange(e, 'uf')}
                  placeholder="Selecione a UF"
                  value={this.state.uf}
                  itemList={this.carregaUfDosMunicipios()}
                  custom
                />
              </Grid>
            ) : ''}
            {this.state.exibirCampoNome ? (
              <Grid cols="4 4 4 4">
                <Input
                  label="Nome"
                  name="destinatario-rpps"
                  onChange={e => this.handleChange(e, 'destinatario-rpps')}
                  placeholder="Selecione o destinatário"
                  value={this.state['destinatario-rpps']}
                  itemList={this.listaFiltradaDestinatarios()}
                  custom
                />
              </Grid>
            ) : ''}
          </div>
        }
        {((ehPapelObservadorPagamento(this.props.papelUsuarioLogado) && this.props.tipoControle === 'pendencias') ||
        this.props.tipoControle === 'pendencias') &&
          <div className="row" >
            <Grid cols="1 1 1 1" style={rowStyle}>
              <div >
                <Input
                  id="desconsiderarFluxosExtraordinarios"
                  onChange={e => this.handleChange(e, 'desconsiderarFluxosExtraordinarios')}
                  check
                  value={this.state.desconsiderarFluxosExtraordinarios}
                />
              </div>
            </Grid>
            <span style={spanStyle}>
              Desconsiderar fluxos extraordinários.
            </span>
          </div>
        }
      </React.Fragment>
    );
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }

    return (
      <DtpPanel
        icon="ico-filter"
        title="Filtro de Pesquisa"
      >
        {filtrosPesquisa}
        <div className="row">
          <Button
            className="dtp-primary right"
            title="Pesquisar"
            onClick={() => this.handleSearchButton()}
            hint="Pesquisar de acordo com o filtro aplicado"
          />
        </div>
      </DtpPanel>
    );
  }
}

FiltroControlePagamentos.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  competencia: PropTypes.string,
  tipoControle: PropTypes.string,
  papelUsuarioLogado: PropTypes.string,
  visaoRota: PropTypes.string,
  history: PropTypes.shape({
    action: PropTypes.string,
  }).isRequired,
}.isRequired;

export default FiltroControlePagamentos;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/FiltroControlePagamentos.jsx